export enum StatusNota {
  NOTA_AUTORIZADA = <any> "Nota autorizada",
  NOTA_EMITIDA_EM_CONTIGENCIA = <any> "Nota emitida em contingência pendente de transmissão",
  NOTA_REJEITADA = <any> "Nota rejeitada",
  NOTA_DENEGADA = <any> "Nota denegada",
  NOTA_INEXISTENTE = <any> "Nota inexistente",
  NOTA_CANCELADA = <any> "Nota cancelada"
}



// WEBPACK FOOTER //
// ./src/app/util/enum/status-nota.enum.ts